// Third party modules;
import React from 'react';

// HelpBot admin modules;
import app from './app';
import Drop from './Drop';

const MenuTab = ({ label, ...props }) => {

   const click = (action) => {
      if ('API' === action) {
         const url = new URL(window.location.href);
         const api = url.href.replace('admin', 'docs').replace(':3000', '').replace(/\/+$/, '');
         window.open(api, '_blank', 'noreferrer');
      } else {
         app.set_state('mode', action.replaceAll(' ', ''));
      }
   } // click();

   const menu = app.menu;

   var style  = null;

   for (var ith = 0; ith < menu.length; ith++) {
      if (label === menu[ith].label) {
         const tab = menu[ith];
         if ('User' === label) {
            label = app.state.name_full;
            style = {float:'right'}
         } else {
            style = null;
         }
         return(
            <Drop 
               callback={click} 
               list={[ label, ...tab.items ]}
               list_style={tab.style}
               prefix={tab.prefix}
               style={style}
            />
         );
      }
   }

   return null;

} // <MenuTab />

const Menu = () => {

   return(
      <div className="ask-henry-menu">
        <MenuTab label="API" />
        <Spacer />
        <MenuTab label="Application" />
        <Spacer />
        <MenuTab label="Knowledge" />
        <Spacer />
        <MenuTab label="Report" />
        <Spacer />
        <MenuTab label="Test" />
        <MenuTab label="User" />
      </div>
   );

} // <Menu />

const Spacer = () => {

   return(<> &nbsp; | &nbsp; </>);

} // <Spacer />

export default Menu;